import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {EnvironmentService} from "./environment.service";
import {
    ActionResult,
    ActionResultList, CategoryItem, Country, DuplicateCandidate,
    LeagueCompetitor,
    LeagueCompetitorFilter,
    PagedFilter
} from "@model";
import {finalize, map, Observable} from "rxjs";
import {LoaderService} from "./loader.service";

@Injectable({ providedIn: 'root' })
export class LeagueCompetitorsService {

    constructor(private http: HttpClient,
                private loaderService: LoaderService,
                private environmentService: EnvironmentService) {
    }

    getLeagueCompetitors(leagueId: number, filter: PagedFilter<LeagueCompetitorFilter>, isAdmin: boolean = false): Observable<LeagueCompetitor[]> {
        const url = isAdmin
            ? `${this.environmentService.getApiUrl()}/api/league/competitors/${leagueId}`
            : `${this.environmentService.getApiUrl()}/api/public/league/competitors/${leagueId}`;

        return this.http.post<ActionResultList<LeagueCompetitor[], number>>(url, filter).pipe(
            map(res => res?.result ?? [])
        );
    }

    getLeagueDuplicateCompetitorsCandidates(leagueId: number): Observable<DuplicateCandidate[]> {
        const url =  `${this.environmentService.getApiUrl()}/api/league/competitors/${leagueId}/duplicates`;

        return this.http.get<ActionResultList<DuplicateCandidate[], number>>(url).pipe(
            map(res => res?.result ?? [])
        );
    }

    getLeagueCompetitorsCountries(leagueId: number): Observable<Country[]> {
        const url =  `${this.environmentService.getApiUrl()}/api/public/league/competitors/${leagueId}/countries`;

        return this.http.get<ActionResultList<Country[], number>>(url).pipe(
            map(res => res?.result ?? [])
        );
    }

    getLeagueCompetitorsCategoryItems(leagueId: number): Observable<CategoryItem[]> {
        const url =  `${this.environmentService.getApiUrl()}/api/public/league/competitors/${leagueId}/categories`;

        return this.http.get<ActionResultList<CategoryItem[], number>>(url).pipe(
            map(res => res?.result ?? [])
        );
    }

   detachLeagueCompetitors(leagueId: number, competitorId: number, detachList: LeagueCompetitor[], onSuccess?: () => void, onError?: () => void) : void {
       const url =  `${this.environmentService.getApiUrl()}/api/league/${leagueId}/competitor/${competitorId}/detach`;
       this.loaderService.startLoading();
       this.http.post<ActionResult<boolean>>(url, detachList)
           .pipe(
               finalize(() => this.loaderService.dismissLoading()))
           .subscribe(actionResult => {
               actionResult?.result ? onSuccess?.() : onError?.();
           });
   }


    resolveDuplicate(leagueId: number, candidate: DuplicateCandidate, onSuccess?: () => void, onError?: () => void): void {
        const url =  `${this.environmentService.getApiUrl()}/api/league/competitors/${leagueId}/duplicate/resolve`;
        this.loaderService.startLoading();
        this.http.post<ActionResult<boolean>>(url, candidate)
            .pipe(
                finalize(() => this.loaderService.dismissLoading()))
                .subscribe(actionResult => {
                    actionResult?.result ? onSuccess?.() : onError?.();
                });
    }


    getMatchHistory(leagueId: number, competitorId: number): Observable<LeagueCompetitorMatchingData | undefined> {
        const url =  `${this.environmentService.getApiUrl()}/api/league/${leagueId}/competitor/${competitorId}/match/data`;
        return this.http.get<ActionResult<LeagueCompetitorMatchingData>>(url).pipe(
            map(res => res?.result)
        );
    }
}


export class LeagueCompetitorMatchingData {
    competitor?: LeagueCompetitor;
    matchedTo?: LeagueCompetitor;
    matchedFrom?: LeagueCompetitor[];
}